import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import dayjs from 'dayjs'
import { Card, Grid } from '@mui/material'

import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../../../constants/page-urls'
import LeadListNotificationFilter, {
  IFilterMapped,
} from './components/LeadListNotificationFilter'
import LeadListNotificationTable from './components/LeadListNotificationTable'
import useAxios from '../../../../../../hooks/useAxios'
import {
  ILeadAssignTo,
  ITrackingNotificationsGetReportAssignTo,
} from '../../../../../../types/trackingNotification'
import { message } from 'antd'
import { LeadListNotificationDetailModal } from './components/LeadListNotificationDetailModal'

const Menus: any[] = []

const LeadListNotificationPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)

  const [
    isModalListDetailLeadListNotification,
    setIssModalListDetailLeadListNotification,
  ] = useState<boolean>(false)
  const [selectAssignTo, setSelectAssignTo] = useState<ILeadAssignTo>()
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : dayjs().format(),
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : dayjs().format(),
  })

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      page: 1,
    }
    setFilter(filter)
    setSearchFilter(filter)
    const newQuery = queryString.stringify({ ...filter })
    navigate(`${PageUrls.CRM.Lead.Notification}?${newQuery}`, {
      replace: true,
    })
  }

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.CRM.Lead.Notification}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    //handleSearch(filter)
  }, [])

  const assignToReportList = useAxios<
    ITrackingNotificationsGetReportAssignTo[]
  >({
    method: 'GET',
    url: '/lead/tracking-notification-assign-to-reports',
    params: {
      ...searchFilter,
    },
  })

  const onUpdateAssignToReportListSuccess = useCallback(async () => {
    try {
      await assignToReportList.mutate()
    } catch (error) {
      message.error('ไม่สามารถดึงข้อมูล Lead Pipeline ได้')
    }
  }, [assignToReportList])

  return (
    <ContentWrapper>
      <Helmet title="รายงานสถานะการติดตาม Lead" />
      <LeadListNotificationDetailModal
        isOpen={isModalListDetailLeadListNotification}
        onClose={(visible: boolean) =>
          setIssModalListDetailLeadListNotification(visible)
        }
        data={selectAssignTo}
        date={searchFilter}
      />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานสถานะการติดตาม Lead"
            routes={Menus}
            descriptions="รายงานสถานะการติดตาม Lead"
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <LeadListNotificationFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <LeadListNotificationTable
          onPressRow={(assignTo: ILeadAssignTo) => {
            setIssModalListDetailLeadListNotification(true)
            setSelectAssignTo(assignTo)
          }}
          isLoading={assignToReportList.isLoading}
          data={assignToReportList.data}
        />
      </Card>
    </ContentWrapper>
  )
}

export default LeadListNotificationPage
